<template>
    <button 
        type="button"
        class="google-login-btn"
        :class="{ 'google-login-btn--icon': type === 'icon' }"
        @click="handleGoogleLogin"
    >
        <img src="@/assets/images/google-logo.svg" alt="Google" />
        <span v-if="type !== 'icon'" class="google-login-btn__text">
            {{ buttonText }}
        </span>
    </button>
</template>

<script>
import socialLoginMixin from '@/plugins/mixin/social-login.mixin';

export default {
    name: 'GoogleLoginButtonPopup',
    mixins: [socialLoginMixin],
    props: {
        text: {
            type: String,
            default: 'continue_with',
            validator: (value) => ['continue_with', 'signin_with', 'signup_with'].includes(value)
        },
        type: {
            type: String,
            default: 'standard'
        }
    },
    data() {
        return {
            user: {
                _tk: null,
                name: 'google',
                siteId: null,
                redirectUrl: null,
            },
            googleClient: null
        };
    },
    computed: {
        buttonText() {
            const texts = {
                'continue_with': this.$t('Continue with Google'),
                'signin_with': this.$t('Sign in with Google'),
                'signup_with': this.$t('Sign up with Google')
            };
            return texts[this.text] || texts['continue_with'];
        }
    },
    mounted() {
        this.user.siteId = this.$route.query.site_id;
        this.user.redirectUrl = this.$route.query.redirect_url;
        this.initGoogleClient();
    },
    methods: {
        initGoogleClient() {
            if (globalThis.google?.accounts?.oauth2) {
                this.googleClient = globalThis.google.accounts.oauth2.initCodeClient({
                    client_id: globalThis.ENV.VUE_APP_GOOGLE_CLIENT_ID,
                    scope: 'email profile openid',
                    ux_mode: 'popup',
                    callback: this.handleCredentialResponse,
                });
            }
        },
        handleGoogleLogin() {
            if (this.googleClient) {
                this.googleClient.requestCode();
            } else {
                this.$toasted.global.errorMessage(this.$t('Google client not initialized'));
            }
        },
        async handleCredentialResponse(response) {
            try {
                if (response.error) {
                    this.$toasted.global.errorMessage(response.error);
                    return;
                }

                const { data: token_data } = await this.axiosAccount.post('/oauth/google/callback', {
                    code: response.code,
                    redirect_uri: 'postmessage'
                });

                this.user._tk = token_data._tk;
                await this.socialNetWorkSucess(this.user);
            } catch (err) {
                this.showError(err);
            }
        }
    }
};
</script>

<style lang="scss">
.google-login-btn {
    align-items: center;
    background-color: #ffffff;
    border: 1px solid #d6d9dc;
    border-radius: 4px;
    color: #3b4045;
    cursor: pointer;
    display: flex;
    height: 40px;
    justify-content: center;
    line-height: 110%;
    max-width: 100%;
    padding: 0 12px;
    transition: 0.1s all;
    width: 220px;
    flex-wrap: nowrap;

    &:hover {
        background-color: #f8f9f9;
    }

    &--icon {
        width: 40px;
        padding: 0;
    }

    &__text {
        font-size: 13px;
        font-weight: 500;
        letter-spacing: 0.25px;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: auto;
    }

    img {
        height: 16px;
        margin-right: 5px;
        width: 16px;
    }

    &--icon img {
        margin-right: 0;
    }
}
</style>

